/* tslint:disable */
/* eslint-disable */
/**
 * Activity Feed API
 * API for managing activity feed entries including historical events, actions, and notifications.  The activity feed provides a unified timeline of events and actions for insured risks (risques assurés). It supports notifications with read/unread status tracking and badge count for UI display.  ## Entry Types - **Historique**: Historical events (e.g., mandate signed, document uploaded) - **Action**: Actionable items with due dates (e.g., pending approvals, required follow-ups)  ## Sources - **Internal**: Events generated by the platform - **External**: Events from external systems or user actions  ## Entity Links Messages can contain entity references in the format `{EntityType:Guid}` which are resolved using the `entities` array for navigation purposes. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationDto } from './NotificationDto';
import {
    NotificationDtoFromJSON,
    NotificationDtoFromJSONTyped,
    NotificationDtoToJSON,
    NotificationDtoToJSONTyped,
} from './NotificationDto';

/**
 * Paginated response containing list of global notifications
 * @export
 * @interface SearchNotificationsResponse
 */
export interface SearchNotificationsResponse {
    /**
     * List of notification entries
     * @type {Array<NotificationDto>}
     * @memberof SearchNotificationsResponse
     */
    items: Array<NotificationDto>;
    /**
     * Total number of notifications matching the query
     * @type {number}
     * @memberof SearchNotificationsResponse
     */
    totalCount: number;
}

/**
 * Check if a given object implements the SearchNotificationsResponse interface.
 */
export function instanceOfSearchNotificationsResponse(value: object): value is SearchNotificationsResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    return true;
}

export function SearchNotificationsResponseFromJSON(json: any): SearchNotificationsResponse {
    return SearchNotificationsResponseFromJSONTyped(json, false);
}

export function SearchNotificationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchNotificationsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(NotificationDtoFromJSON)),
        'totalCount': json['totalCount'],
    };
}

export function SearchNotificationsResponseToJSON(json: any): SearchNotificationsResponse {
    return SearchNotificationsResponseToJSONTyped(json, false);
}

export function SearchNotificationsResponseToJSONTyped(value?: SearchNotificationsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(NotificationDtoToJSON)),
        'totalCount': value['totalCount'],
    };
}

